/* @flow */
import React from 'react';

import Link from 'components/Link.jsx';
import Group from 'entities/Group';
import GroupAvatar from 'groups/components/GroupAvatar.jsx';
import Text from 'components/Text.jsx';
import Timestamp from 'components/Timestamp.jsx';
import { subgroupName } from 'utils/roleHelpers';

import './styles/ChatListItem.scss';

class AnnouncementThreadListItem extends React.Component {
  props: {
    thread: Object,
    group: Group,
  };

  render() {
    const { thread, group } = this.props;
    const { preview } = thread;

    return (
      <li className="ChatListItem">
        <Link
          to={`/classes/${group.getCode()}/messages/announcements/${thread.role}`}
          activeClassName="ChatListItem-selected"
          className="ChatListItem-link ChatListItem-link-experiment"
          eventElementName="ChatListItem-link ChatListItem-link-experiment">
          <div
            className="ChatListItem-content">
            <div className="ChatListItem-content-droplet">
              <GroupAvatar group={group} className="ChatListItem-announcementBadge" />
            </div>
            <div className="ChatListItem-content-body">
              <div className="ChatListItem-content-body-inner">
                <span className="ChatListItem-name">
                  {subgroupName[thread.role]}
                </span>
                {preview &&
                  <Timestamp
                    className="ChatListItem-date"
                    date={new Date(this.props.thread.preview.sent_at)}
                    format="short"
                  />}
              </div>
              <Text className="ChatListItem-snippet" truncate>
                {preview ? preview.preview : 'Send your first announcement'}
              </Text>
              <hr className="ChatListItem-content-body-divider" />
            </div>
          </div>
        </Link>
      </li>
    );
  }
}

export default AnnouncementThreadListItem;



// WEBPACK FOOTER //
// ./src/chat/components/AnnouncementThreadListItem.jsx